import { AuthorizationUpdated, FeatureEnabled } from "event-definitions"
import { ensureArray } from "lib/ensure-array"
import { noChange } from "lib/@hooks/useRefresh"

export function isEnabled(feature) {
    return FeatureEnabled.call({ feature, enabled: false })
}

export function Feature({ feature, children, fallback = null, or = true }) {
    AuthorizationUpdated.useRefresh(noChange)
    const features = ensureArray(feature)
    const ok = or ? features.some(check) : features.every(check)
    return ok ? children : fallback

    function check(f) {
        return isEnabled(f) || isEnabled(`${f}-all-users`)
    }
}
